<template>
  <div class="news container-fluid">
    <div class="row text-center my-5">
      <div 
        class="col-lg-4 col-md-4 col-sm-12 col-4 card m-auto mb-4" 
        v-for="(event, index) in events" 
        :key="index"
      >
        <img :src="event.image" alt="event-image" class="news__img p-2 mt-3" />
        <div class="card-body">
          <h3 class="card-title">{{ event.title }}</h3>
          <p class="card-text">
            {{ event.date }}<br />
            <i class="fas fa-map-marker-alt blue"></i>
            <span class="blue mx-2">{{ event.location }}</span>
          </p>
          <div class="text-end">
            <DinamicLink :url="event.url" name="Read more" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DinamicLink from '@/components/DinamicLink.vue';

export default {
  name: 'EventsComponent',
  components: {
    DinamicLink
  },
  data() {
    return {
      events: [
      {
          
          image: '/images/y1G9poB.jpg',
          title: 'International Telecoms Week 2024',
          date: '5 - 7 May 2025',
          location: 'Gaylord National Resort & Convention Centre National Harbor',
          url: '/events-gallery'
        },
        {
          
          image: '/images/6G5KxAG.jpg',
          title: 'Channel Partners Conference & Expo 2025',
          date: '24 - 25 March 2025',
          location: 'The Venetian Resort in Las Vegas',
          url: '/events-gallery'
        },
        {
          title: 'Capacity Europe 2024',
          date: '15 - 17 October 2024',
          location: 'InterContinental London - The 02',
          image: '/images/XAx622Y.jpg',
          url: '/events-gallery'
        }
        
      ]
    };
  }
};
</script>

<style scoped>


.news {
  color: black;
  margin: 20vh 0;
}


.row {
  display: flex;
  justify-content: space-between; 
  flex-wrap: nowrap; 
  gap: 20px;
}

.news__img {
  height: 200px;
  width: 100%;
  object-fit: scale-down; 
  transition: transform 0.3s ease; 
}


.news__img:hover {
  transform: scale(1.1); 
}

.card-body {
  padding: 1.5rem;
}

.card-title {
  font-size: 1.25rem;
  font-weight: bold;
}

.card-text {
  font-size: 1rem;
}

.text-end {
  text-align: right;
}

.blue {
  color: #1e5c88; 
}

.m-2 {
  margin: 1rem;
}

@media (max-width: 992px) {
  .news__img {
    height: auto;
  }

  .card-body {
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .news__img {
    height: auto;
  }

  .card-body {
    padding: 1rem;
  }
}
</style>
